<template>
  <div>
    <a-card v-if="listEnable" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品类别">
                <a-select v-model="queryParam.installType" allowClear="true">
                  <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌名称">
                <a-input v-model="queryParam.brandName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" :offset="6" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
        <a-divider></a-divider>
        <a-row>
          <a-col :span="5" :offset="19" :style="{ textAlign: 'right' }">
            <a-button v-if="addEnable" type="primary" icon="plus" @click="handleAdd">新增</a-button>
          </a-col>
        </a-row>
      </div>
      <s-table
        style="margin-top: 15px"
        size="default"
        ref="table"
        rowKey="brandId"
        :columns="columns"
        :data="loadData"
        bordered
      >
      <span slot="action" slot-scope="text, record ">
        <a v-if="queryDetail" @click="handleShow(record)">查看</a>
        <a-divider v-if="queryDetail" type="vertical"/>
        <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
        <a-divider v-if="removeEnable && editEnabel" type="vertical"/>
        <a v-if="removeEnable" @click="delByIds(record.brandId)">删除</a>
        <span v-if="editEnabel">
          <a-divider type="vertical"/>
          <a v-if="record.forbiddenStatus==1" @click="showState(record.brandId,record.forbiddenStatus)">启用</a>
          <a v-else @click="showState(record.brandId,record.forbiddenStatus)">禁用</a>
        </span>
      </span>
      </s-table>
      <bbrand-modal ref="modal" @ok="handleOk"/>
    </a-card>
    <no-authority v-if="!listEnable"></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import { getBrandList, saveBrand, delBrand, banBrand, enanBrand } from '@/api/enterprise/brand'
// import { getDictionary } from '@/api/workflow/dictionaries'
import BbrandModal from './modules/BBrandModal.vue'
import NoAuthority from './NoAuthority'
// 获取权限
import { checkPermission } from '@/utils/permissions'
// import { getMap } from '../../api/workflow/process'
import { pick } from 'lodash.pick'
import {getDictMap} from "../../utils/dict";

export default {
  props: {
  },
  name: 'TableList',
  components: {
    STable,
    BbrandModal,
    NoAuthority
  },
  data () {
    return {
      restaurantTypes: [],
      ok: true,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width:60,
          dataIndex: 'rowNum',
          align:'center'
        },
        {
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '安装类型',
          dataIndex: 'installName',
          align:'center'
        },
        {
          title: '品牌名称',
          dataIndex: 'brandName',
          align:'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align:'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align:'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getBrandList(Object.assign(parameter, this.queryParam))
      },
      listEnable: checkPermission('enterprise:brand:list'),
      addEnable: checkPermission('enterprise:brand:add'),
      editEnabel: checkPermission('enterprise:brand:edit'),
      removeEnable: checkPermission('enterprise:brand:remove'),
      queryDetail: checkPermission('brandList:query:detail'),
    }
  },
  async created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    this.restaurantTypes = [];
    this.restaurantOperTypeMap = await getDictMap('install_type');
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({code: key, label: value})
    })
  },

  methods: {
    showState (brandId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        banBrand({ 'brandId': brandId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enanBrand({ 'brandId': brandId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    handleAdd () {
      this.$refs.modal.add()
    },
    handleShow(record){
      this.$refs.modal.edit(record,1)
    },
    handleEdit (record) {
      // console.log(record)
      this.$refs.modal.edit(record)
    },
    handleOk (value) {
      if(value == 1){
        this.$refs.table.refresh(true)
      }else{
        this.$refs.table.refresh()
      }
    },
    delByIds (brandId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delBrand({ 'brandId': brandId }).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
  .table-operator{
    margin: 10px 0;
  }
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table-content{
    width:50%
  }
</style>
